type FirebaseRuntimeConfig = {
  apiKey?: string
  authDomain?: string
  projectId?: string
  storageBucket?: string
  messagingSenderId?: string
  appId?: string
  measurementId?: string
  useEmulator?: boolean
  offlineMode?: boolean
}

declare global {
  interface Window {
    __INFERGRAPH_FIREBASE_CONFIG__?: FirebaseRuntimeConfig
  }
}

const getRuntimeFirebaseConfig = (): FirebaseRuntimeConfig => {
  if (typeof window === 'undefined') {
    return {}
  }
  return window.__INFERGRAPH_FIREBASE_CONFIG__ ?? {}
}

const getDevFirebaseConfig = (): FirebaseRuntimeConfig => {
  // Vite import.meta.env 는 dev/prod 둘 다 사용 가능. .env.production 의 VITE_FIREBASE_*
  // 값이 production 빌드에도 그대로 inline 됨. window.__INFERGRAPH_FIREBASE_CONFIG__ 가
  // 있으면 그 값이 우선 (런타임 오버라이드용).
  return {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || '',
    useEmulator: import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true',
    offlineMode: import.meta.env.VITE_FIREBASE_OFFLINE_MODE === 'true',
  }
}

export const getFirebaseRuntimeConfig = (): Required<FirebaseRuntimeConfig> => {
  const runtimeConfig = getRuntimeFirebaseConfig()
  const devConfig = getDevFirebaseConfig()
  const config = { ...devConfig, ...runtimeConfig }

  return {
    apiKey: config.apiKey || '',
    authDomain: config.authDomain || '',
    projectId: config.projectId || '',
    storageBucket: config.storageBucket || '',
    messagingSenderId: config.messagingSenderId || '',
    appId: config.appId || '',
    measurementId: config.measurementId || '',
    useEmulator: Boolean(config.useEmulator),
    offlineMode: Boolean(config.offlineMode),
  }
}

